<template>
  <gg-modal :is-active="isActive" @close="close">
    <template v-slot:toolbar>
      Create Forwarder
    </template>
    <template v-slot:body>
      <v-form class="pt-2" @submit.prevent="create">
        <v-row>
          <v-col cols="12" class="py-0">
            <gg-input-label>Forward From</gg-input-label>
            <p class="body-2 mb-4">{{ mailbox.email }}</p>
          </v-col>
          <v-col cols="12" class="py-0">
            <gg-text-field
              outlined
              dense
              label="Forward To"
              placeholder="ex. someone@example.com"
              autocomplete="off"
              v-model="destination"
              v-validate="'required|email'"
              name="Destination"
              :error-messages="errors.collect('Destination')"
            />
          </v-col>
          <v-col cols="12" class="pt-0">
            <p class="body-2 mb-0">
              A copy of every message to <strong>{{ mailbox.email }}</strong> will also
              be sent to <strong>{{ destination || 'this address' }}</strong>. The
              mailbox keeps its own copy.
            </p>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <v-spacer></v-spacer>
      <gg-btn secondary @click="close">Cancel</gg-btn>
      <gg-btn primary :loading="saving" @click="create">Create Forwarder</gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions } from 'vuex'

/**
 * Forward a mailbox's mail on to another address (AM-1106). The reverse of an
 * alias: there the mailbox is the destination, here it is the source, so the
 * destination is free text and may be off the account.
 */
export default {
  name: 'CreateForwarderModal',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    mailbox: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      destination: '',
      saving: false,
    }
  },
  methods: {
    ...mapActions('emailHub', ['addMailboxForwarder']),
    ...mapActions(['reportError', 'reportSuccess']),
    close () {
      this.$emit('close')
    },
    // Reset on open, not on close, so reopening on another row starts clean.
    open () {
      this.destination = ''
      this.$validator.reset()
    },
    async create () {
      const valid = await this.$validator.validateAll()
      if (!valid) return

      this.saving = true
      try {
        await this.addMailboxForwarder({
          serviceId: this.mailbox.serviceId,
          email: this.mailbox.email,
          domain: this.mailbox.domain,
          destination: this.destination.trim(),
        })
      } catch (e) {
        this.saving = false
        this.reportError(e)
        return
      }

      this.saving = false
      this.reportSuccess('Forwarder successfully created.')
      this.$emit('created')
      this.close()
    },
  },
  watch: {
    isActive (active) {
      if (active) this.open()
    },
  },
  // Mounted already open from the dashboard row — see AddAliasModal.open().
  created () {
    if (this.isActive) this.open()
  },
}
</script>
